import React from 'react';
import { SVGIconProps } from './props';

const InfoSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M1.10791 0.650391V2.82397C8.12253 2.82397 13.8309 8.67325 13.8309 15.8657H15.9513C15.9513 7.4753 9.29323 0.650391 1.10791 0.650391Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
                <path
                    d='M1.10791 4.99756V7.1714C5.78579 7.1714 9.59001 11.0704 9.59001 15.8657H11.7105C11.7104 9.87268 6.95416 4.99756 1.10791 4.99756Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
                <path
                    d='M1.10791 9.34473V11.5186C3.44729 11.5186 5.3491 13.4681 5.3491 15.8658H7.46955C7.46955 12.2681 4.61562 9.34473 1.10791 9.34473Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
                <path
                    d='M1.53219 13.8599C0.686028 13.8599 0 14.5624 0 15.4301C0 16.2977 0.686028 17.0004 1.53219 17.0004C2.37832 17.0004 3.06435 16.2977 3.06435 15.4301C3.06435 14.5624 2.37832 13.8599 1.53219 13.8599Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
            </svg>
        </span>
    );
};

export default InfoSVGIcon;
